/**
* Global Options for Toast Notifications
* These options will be taken by default if user doesn't provide customizations
*/
export const TN_GLOBAL_OPTIONS: any = {
  position: ["top", "right"],
  timeOut: 5000,
  lastOnBottom: true,
  showProgressBar: true,
  pauseOnHover: true,     //as per Sathish's request, should be false
  maxLength: 250,         //still undetermined
  maxStack: 8,
  animate: 'fromRight',
  theClass: 'tnMessageNotification'
}

/**
* Options for customizations
*/
export enum TN_OPTIONS_FOR_MESSAGE {
  TIME_OUT = 'timeOut',
  SHOW_PROGRESS_BAR = 'showProgressBar',
  PAUSE_ON_HOVER = 'pauseOnHover',
  CLICK_TO_CLOSE = 'clickToClose',
  ANIMATE = 'animate'
}

/**
* Animations for customizations
*/
export enum TN_TRANSITIONS {
  FADE = 'fade',
  FROM_TOP = 'fromTop',
  FROM_RIGHT = 'fromRight',
  FROM_BOTTOM = 'fromBottom',
  FROM_LEFT = 'fromLeft',
  SCALE = 'scale',
  ROTATE = 'rotate'
}

/**
* Notification types
*/
export enum TN_MESSAGE_TYPE {
  ALERT = 'alert',
  ERROR = 'error',
  INFO = 'info',
  WARN = 'warn',
  SUCCESS = 'success'
}



// WEBPACK FOOTER //
// ./src/app/shared/constants/toast-notification.constants.ts